import { getField, updateField } from 'vuex-map-fields';
import AdminService from '@/services/AdminService';

const getDefaultState = function () {
    return {
        id: null,
        name: null,
        name2: null,
        name3: null,
        name4: null,
        link1: null,
        link2: null,
        link3: null,
        htmlContent: null,
        status: null,
        isInteractiveVideo: null,
        thumbnailUrl: null,
        durationInSeconds: null,
        exerciseCategoryId: null,
        videoTypeId: null
    };
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = getDefaultState();

const getters = {
    getField,
    form: (state) => ({
        id: state.id,
        name: state.name,
        name2: state.name2,
        name3: state.name3,
        name4: state.name4,
        link1: state.link1,
        link2: state.link2,
        link3: state.link3,
        htmlContent: state.htmlContent,
        status: state.status,
        isInteractiveVideo: state.isInteractiveVideo,
        thumbnailUrl: state.thumbnailUrl,
        durationInSeconds: state.durationInSeconds,
        exerciseCategoryId: state.exerciseCategoryId,
        videoTypeId: state.videoTypeId,
    }),
};

const mutations = {
    setVideo(state, value) {
        if (value) {
            // value.Transfers.forEach((status) => {
            //     status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
            // });
            Object.assign(state, value);
        } else {
            Object.assign(state, getDefaultState());
        }
    },

    storeReportDetails(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadVideo({ commit }, data) {
        // const course = JSON.parse(localStorage.getItem('course'));
        const res = await AdminService.getVideosInBank({
            EntityId: data.id
        });
        commit('setVideo', res.data.items[0]);
        return res.data;
    },
    async loadVideoAdmin({ commit }, data) {
        const res = await AdminService.getReportAdmin(data.id);
        commit('setVideo', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
